import _ from 'lodash'
import { holidays } from './date-helpers-holidays.js'
import moment from 'moment-timezone'


export const checkIfWeekend = (dow = moment().tz("America/Chicago").day()) => {
    return (dow === 6 || dow === 7) ? true : false
}

export const checkIfHoliday = (todayDate = moment().format('YYYY-MM-DD')) => {
    const todayDateRepeatFormat = `--${todayDate.slice(5)}`
    const holidayItemFromRepeatDates = _.find(holidays['repeating'], {date: todayDateRepeatFormat })
    const holidayItemFromExplicitDates = _.find(holidays['explicit'], { date: todayDate })

    return holidayItemFromRepeatDates || holidayItemFromExplicitDates
}